import {
	MinusCircleOutlined,
	PlusCircleOutlined,
	UploadOutlined,
} from '@ant-design/icons';
import { Button, message, Modal, Upload } from 'antd';
import { Form, Input, Space } from 'antd/es';
import React, { useEffect, useState } from 'react';
import { useUploadInvoice } from './store';
const InvoiceUploader = ({
	orderId,
	isModalVisible,
	setModalVisible,
	refreshUi,
}) => {
	const [form] = Form.useForm();
	const [file, setFile] = useState(false);
	const [uploadButton, setUploadButton] = useState('Select PDF file');
	const [uploadRequired, setUploadRequired] = useState(false);

	const [formFields, setFormFields] = useState([
		{
			productLongName: '',
			productShortName: '',
			hsn: '',
			gst_rate: '',
			quantity: '',
			price: '',
			mrp: '',
			discount: '',
			grossSales: '',
			taxable: '',
			igst: '',
			cgst: '',
			sgst: '',
			total_gst: '',
			shipping_charge: '',
		},
	]);
	const { uploadInvoiceData, uploadInvoice } = useUploadInvoice();

//   useEffect(() => {
//     setOrders(uploadInvoiceData);
//   }, [uploadInvoiceData]);

	const handleAddField = () => {
		const newField = {
			productLongName: '',
			productShortName: '',
			hsn: '',
			gst_rate: '',
			quantity: '',
			price: '',
			mrp: '',
			discount: '',
			grossSales: '',
			taxable: '',
			igst: '',
			cgst: '',
			sgst: '',
			total_gst: '',
			shipping_charge: '',
		};

		setFormFields([...formFields, newField]);
	};

	const handleFileUpload = async file => {
		if (file.type !== 'application/pdf') {
			message.error('Please upload a PDF file!');
			return false;
		}
		setUploadButton(file.name);
		setFile(file);
		setUploadRequired(false);
	};

	const handleRemoveField = index => {
		const updatedFields = [...formFields];
		updatedFields.splice(index, 1);
		setFormFields(updatedFields);
	};

	const validateFloat = (_, value) => {
		if (value && !/^\d+(\.\d+)?$/.test(value)) {
			return Promise.reject('Please enter a valid number');
		}
		return Promise.resolve();
	};

	const handleSubmit = () => {
		if (!file) {
			message.warn('Please upload invoice pdf');
			setUploadRequired(true);
			return false;
		}
		form.validateFields().then(async values => {
			const result = Object.entries(values).reduce((acc, [key, value]) => {
				const [name, index] = key.split('-');
				acc[index] = acc[index] || {};
				acc[index][name] = value;
				return acc;
			}, []);
			const formData = new FormData();
			formData.append('file', file);
			formData.append('invoiceDataArray', JSON.stringify(result));
			formData.append('orderId', orderId);

			const apiReq = await uploadInvoice(formData);

			if (!apiReq.hasError) {
				message.success('Uploaded successfully');
				setModalVisible(false);
				if (refreshUi) refreshUi();
			} else {
				message.error('Failed to upload');
			}
		});
	};

	return (
		<>
			<Modal
				title="Invoice Upload"
				visible={isModalVisible}
				onCancel={() => setModalVisible(false)}
				footer={[
					<Button key="cancel" onClick={() => setModalVisible(false)}>
						Cancel
					</Button>,
				]}>
				<Upload beforeUpload={handleFileUpload} showUploadList={false}>
					<Button icon={<UploadOutlined />}>{uploadButton}</Button>
				</Upload>
				{uploadRequired && <h4 style={{ color: 'red' }}>* Upload pdf</h4>}
				<hr />
				<div>
					<h2>
						<strong>Add invoice details</strong>
					</h2>
					<Form form={form}>
						{formFields.map((field, index) => (
							<Space key={index} direction="vertical">
								<h3>
									<b>
										<u>Item #{index + 1}</u>
									</b>
								</h3>
								<Form.Item
									name={`productLongName-${index}`}
									label="Product Long Name"
									rules={[
										{
											required: true,
											message: 'Please enter Product Long Name',
										},
									]}>
									<Input />
								</Form.Item>
								<Form.Item
									name={`productShortName-${index}`}
									label="Product Short Name"
									rules={[
										{
											required: true,
											message: 'Please enter Product Short Name',
										},
									]}>
									<Input />
								</Form.Item>
								<Form.Item
									name={`hsn-${index}`}
									label="HSN"
									rules={[{ required: true, message: 'Please enter HSN' }]}>
									<Input />
								</Form.Item>
								<Form.Item
									type="float"
									name={`gst_rate-${index}`}
									label="GST Rate"
									rules={[
										{ required: true, message: 'Please enter GST Rate' },
										{ validator: validateFloat },
									]}>
									<Input />
								</Form.Item>
								<Form.Item
									name={`quantity-${index}`}
									label="Quantity"
									rules={[
										{ required: true, message: 'Please enter Quantity' },
										{ validator: validateFloat },
									]}>
									<Input />
								</Form.Item>

								<Form.Item
									name={`price-${index}`}
									label="Price"
									rules={[
										{ required: true, message: 'Please enter Price' },
										{ validator: validateFloat },
									]}>
									<Input />
								</Form.Item>

								<Form.Item
									name={`mrp-${index}`}
									label="MRP"
									rules={[
										{ required: true, message: 'Please enter MRP' },
										{ validator: validateFloat },
									]}>
									<Input />
								</Form.Item>

								<Form.Item
									name={`discount-${index}`}
									label="Discount"
									rules={[
										{ required: true, message: 'Please enter Discount' },
										{ validator: validateFloat },
									]}>
									<Input />
								</Form.Item>
								<Form.Item
									name={`grossSales-${index}`}
									label="Gross Sales"
									rules={[
										{ required: true, message: 'Please enter Gross sales' },
										{ validator: validateFloat },
									]}>
									<Input />
								</Form.Item>
								<Form.Item
									name={`taxable-${index}`}
									label="Taxable"
									rules={[
										{ required: true, message: 'Please enter Taxable' },
										{ validator: validateFloat },
									]}>
									<Input />
								</Form.Item>

								<Form.Item
									name={`igst-${index}`}
									label="IGST"
									rules={[
										{ required: true, message: 'Please enter IGST' },
										{ validator: validateFloat },
									]}>
									<Input />
								</Form.Item>
								<Form.Item
									name={`sgst-${index}`}
									label="SGST"
									rules={[
										{ required: true, message: 'Please enter SGST' },
										{ validator: validateFloat },
									]}>
									<Input />
								</Form.Item>
								<Form.Item
									name={`cgst-${index}`}
									label="CGST"
									rules={[
										{ required: true, message: 'Please enter CGST' },
										{ validator: validateFloat },
									]}>
									<Input />
								</Form.Item>
								<Form.Item
									name={`total_gst-${index}`}
									label="Total GST"
									rules={[
										{ required: true, message: 'Please enter Total GST' },
										{ validator: validateFloat },
									]}>
									<Input />
								</Form.Item>

								<Form.Item
									name={`shipping_charge-${index}`}
									label="Shipping Charge"
									rules={[
										{ required: true, message: 'Please enter Shipping charge' },
										{ validator: validateFloat },
									]}>
									<Input />
								</Form.Item>

								{index > 0 && (
									<Button
										style={{ marginBottom: '10px' }}
										type="dashed"
										icon={<MinusCircleOutlined style={{ color: 'red' }} />}
										onClick={() => handleRemoveField(index)}>
										Remove Above Item
									</Button>
								)}
							</Space>
						))}

						<Form.Item>
							<Button
								type="dashed"
								icon={<PlusCircleOutlined />}
								onClick={handleAddField}>
								Add More Item
							</Button>
						</Form.Item>

						<Form.Item>
							<Button type="primary" onClick={handleSubmit}>
								Submit
							</Button>
						</Form.Item>
					</Form>
				</div>
			</Modal>
		</>
	);
};

export default InvoiceUploader;
